module.exports = __webpack_public_path__ + "img/play.7900588b.png";